import { combineReducers } from "redux";

import contactReducer from "./Contact/reducers";

export const rootReducer = combineReducers({
    contactReducer: contactReducer
});

export type RootState = ReturnType<typeof rootReducer>;
